<nav class="navbar navbar-expand-lg navbar-light bg-light mb-0">

  <button type="button" id="sidebarCollapse" class="btn btn-info" (click)="toggleSidebar()" *ngIf="!deviceService.isDesktop()">
    <i class="fas fa-align-left"></i>
  </button>

  <div class="bg-white" *ngIf="deviceService.isMobile()">
    <button class="ml-auto btn btn-info" type="button" data-toggle="collapse"
            data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="mostra navbar"
            #navbarCollapsibleBtnRef (click)="forceSidebarMinimize()">
      <i class="fas fa-bars"></i>
    </button>
  </div>

  <div class="navbar-collapse" id="navbarContent" #navbarCollapsibleContentRef [ngSwitch]="isAuthenticated()"
       [ngClass]="deviceService.isMobile() ? 'collapse' : ''">

    <div class="sidebar-header text-center">
      <div class="row">
        <div [ngClass]="!isMinimized() ? 'py-1 px-2' : 'pt-1'">
          <button type="button" id="sidebarCollapse" (click)="toggleSidebar()"
            [ngClass]="isMinimized() ? 'ml-2 sidebar-toggler-btn-minimized' : 'sidebar-toggler-btn'">
            <i class="fas fa-fw fa-bars"></i>
          </button>
        </div>
        <div class="px-2 py-0">
          <a [routerLink]="'/'" routerLinkActive="active">
            <img src="assets/img/logo_bianco.png" alt="{{'ramConsulting' | translate}}" class="navbar-logo align-center">
          </a>
        </div>
      </div>
    </div>

    <ul class="navbar-nav ml-auto float-right">

      <!-- SCELTA LINGUA -->
      <div class="container">
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="javascript:void(0);" id="languagesDropdown"
             role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="flag-icon flag-icon-{{i18nService.language}}" style="font-size: 1.5rem;"></span>
          </a>
          <div class="dropdown-menu dropdown-menu-right m-0" aria-labelledby="languagesDropdown">
            <a *ngFor="let language of languages" class="dropdown-item" href="javascript:void(0);"
               (click)="changeLanguage(language.code)">
              <i class="flag-icon flag-icon-{{language.code}} h2 mb-0"
                 style="font-size: 1.5rem;"></i>
              &nbsp;<span style="vertical-align: super;">{{ language.description }}</span>
            </a>
          </div>
        </li> -->

        <!-- MENU UTENTE -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="javascript:void(0);" id="accountMenu"
             role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span>
              <img src="../../../../assets/img/unknown_avatar.png" class="profile-image rounded-circle" alt="Avatar">
            </span>
            &nbsp;<span class="h6">{{userService.getCurrentUser()?.firstName + ' ' + userService.getCurrentUser()?.lastName}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right m-0" aria-labelledby="accountMenu">
            <a class="dropdown-item cursor-pointer" (click)="router.navigate(['/dettaglio-utente'])" id="dettaglioUtente">
              <i class="fas fa-user-edit fa-fw" aria-hidden="true"></i>&nbsp;<span translate>{{'dettaglioUtente'|translate}}</span>
            </a>
            <a class="dropdown-item cursor-pointer" (click)="logout()" id="logout">
              <i class="fas fa-sign-out-alt fa-fw" aria-hidden="true"></i>&nbsp;<span translate>{{'logout'|translate}}</span>
            </a>
          </div>
        </li>
      </div>

    </ul>
  </div>
</nav>
